<form [formGroup]="emailForm" role="form">
    <div class="modal-body">
        <div class="row">
            <div class="form-group col">
                <label for="to">{{ 'email.tos' | translate }}</label>
                <input type="text"
                       id="to"
                       formControlName="to"
                       name="to"
                       class="form-control"/>
                <div *ngIf="tosInvalidEmails">
                    <p style="color: red;"> {{ 'email.invalid_emails' | translate }}: {{ tosInvalidEmailsMessage }}</p>
                </div>
                <div *ngIf="tosRequired">
                    <p style="color: red;">{{'base.field_required' | translate}}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label for="bcc">{{ 'email.bcc' | translate }}</label>
                <input type="text"
                       id="bcc"
                       name="bcc"
                       formControlName="bcc"
                       class="form-control"/>
                <span *ngIf="bccInvalidEmails">
                                 <small class="text-danger">
                                          {{ 'email.invalid_emails' | translate }}: {{ bccInvalidEmailsMessage }}
                                 </small>
                          </span>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label for="ccn">{{ 'email.ccn' | translate }}</label>
                <input type="text"
                       id="ccn"
                       name="ccn"
                       formControlName="ccn"
                       class="form-control"/>
                <span *ngIf="ccnInvalidEmails">
                                 <small class="text-danger">
                                          {{ 'email.invalid_emails' | translate }}: {{ ccnInvalidEmailsMessage }}
                                 </small>
                          </span>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label for="subject">{{ 'email.subject' | translate }}</label>
                <input type="text"
                       id="subject"
                       name="subject"
                       formControlName="subject"
                       class="form-control"/>
                <div *ngIf="subjectRequired">
                    <p style="color: red;">{{'base.field_required' | translate}}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group col">
                <label for="body">{{ 'email.body' | translate }}</label>
                <textarea
                        id="body"
                        name="body"
                        class="form-control"
                        formControlName="body"
                        rows="5">
                          </textarea>
                <div *ngIf="bodyRequired">
                    <p style="color: red;">{{'base.field_required' | translate}}</p>
                </div>
            </div>
        </div>
        <div [hidden]="uploaderHidden" class="row">
            <app-uploader></app-uploader>
        </div>
    </div>
</form>
